import { render } from "./PSBPayButton.vue?vue&type=template&id=79cb45f5&ts=true"
import script from "./PSBPayButton.vue?vue&type=script&lang=ts"
export * from "./PSBPayButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__